export function handleFetchItemsPending(state) {
    state.query = '';
    state.queryModification = {
        originalQuery: '',
        newQuery: '',
        queryToIgnore: state.queryModification.queryToIgnore,
    };
    return state;
}
export function handleFetchItemsFulfilled(state, triggers) {
    const redirectTriggers = [];
    const queryTriggers = [];
    const executeTriggers = [];
    const notifyTriggers = [];
    triggers.forEach((trigger) => {
        switch (trigger.type) {
            case 'redirect':
                redirectTriggers.push(trigger.content);
                break;
            case 'query':
                queryTriggers.push(trigger.content);
                break;
            case 'execute':
                executeTriggers.push({
                    functionName: trigger.content.name,
                    params: trigger.content.params,
                });
                break;
            case 'notify':
                notifyTriggers.push(trigger.content);
                break;
        }
    });
    state.redirectTo = redirectTriggers[0] ?? '';
    state.query = state.queryModification.newQuery;
    state.executions = executeTriggers;
    state.notifications = notifyTriggers;
    return state;
}
export function handleApplyQueryTriggerModification(state, payload) {
    state.queryModification = { ...payload, queryToIgnore: '' };
    return state;
}
export function handleUpdateIgnoreQueryTrigger(state, payload) {
    state.queryModification.queryToIgnore = payload;
    return state;
}
